import { Home, Compass, PlusCircle, Disc, Menu, type LucideIcon } from 'lucide-react';

export type NavItemType = 'link' | 'action' | 'sheet';

export interface NavItem {
  path: string | null;
  labelKey: string;
  label: string;
  icon: LucideIcon;
  type: NavItemType;
  requiresAuth?: boolean;
  showInBottomNav?: boolean;
  showInHeader?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: '/gallery',
    labelKey: 'header.mobile.home',
    label: '홈',
    icon: Home,
    type: 'link',
    showInBottomNav: true,
    showInHeader: true,
  },
  {
    path: '/templates',
    labelKey: 'header.mobile.explore',
    label: '탐색',
    icon: Compass,
    type: 'link',
    showInBottomNav: true,
    showInHeader: true,
  },
  {
    path: null,
    labelKey: 'header.mobile.create',
    label: '만들기',
    icon: PlusCircle,
    type: 'action',
    requiresAuth: true,
    showInBottomNav: true,
    showInHeader: false,
  },
  {
    path: '/albums',
    labelKey: 'header.mobile.albums',
    label: '내 앨범',
    icon: Disc,
    type: 'link',
    requiresAuth: true,
    showInBottomNav: true,
    showInHeader: true,
  },
  {
    path: null,
    labelKey: 'header.mobile.more',
    label: '더보기',
    icon: Menu,
    type: 'sheet',
    showInBottomNav: true,
    showInHeader: false,
  },
];

export function getVisibleNavItems(target: 'bottom' | 'header'): NavItem[] {
  return NAV_ITEMS.filter((item) => {
    if (target === 'bottom' && !item.showInBottomNav) return false;
    if (target === 'header' && !item.showInHeader) return false;
    return true;
  });
}

export function isNavItemActive(pathname: string, item: NavItem): boolean {
  if (!item.path) return false;
  if (item.path === '/') return pathname === '/';
  return pathname === item.path || pathname.startsWith(item.path + '/');
}
